(function () {
  function init() {
    var root = document.querySelector('[data-wakaba-catalog]');
    if (!root) return;

    var pages = (window.WAKABA_CATALOG_PAGES || []).filter(Boolean);
    if (pages.length === 0) return;

    var stage = root.querySelector('[data-wakaba-book]');
    var prevBtn = root.querySelector('[data-wakaba-prev]');
    var nextBtn = root.querySelector('[data-wakaba-next]');
    var info = root.querySelector('[data-wakaba-info]');
    var loading = root.querySelector('[data-wakaba-loading]');

    if (!stage || typeof St === 'undefined' || !St.PageFlip) {
      console.warn('[wakaba-catalog] StPageFlip not loaded');
      return;
    }

    var pageFlip = new St.PageFlip(stage, {
      width: 600,
      height: 848,
      size: 'stretch',
      minWidth: 200,
      maxWidth: 700,
      minHeight: 283,
      maxHeight: 990,
      maxShadowOpacity: 0.5,
      showCover: true,
      mobileScrollSupport: false,
      usePortrait: false,
      drawShadow: true,
      flippingTime: 700
    });

    pageFlip.loadFromImages(pages);

    if (loading) loading.classList.add('is-hidden');

    var soundUrl = root.getAttribute('data-flip-sound') || '';
    var audioPool = [];
    var audioIdx = 0;
    var soundReady = false;
    if (soundUrl) {
      var probe = new Audio(soundUrl);
      probe.addEventListener('canplaythrough', function () {
        soundReady = true;
        for (var i = 0; i < 4; i++) {
          var a = new Audio(soundUrl);
          a.preload = 'auto';
          a.volume = 0.6;
          audioPool.push(a);
        }
      }, { once: true });
      probe.addEventListener('error', function () { soundReady = false; }, { once: true });
      probe.preload = 'auto';
      try { probe.load(); } catch (e) { }
    }

    var audioCtx = null;
    function playSynthFlip() {
      try {
        var AC = window.AudioContext || window.webkitAudioContext;
        if (!AC) return;
        if (!audioCtx) audioCtx = new AC();
        if (audioCtx.state === 'suspended') audioCtx.resume();
        var ctx = audioCtx;
        var now = ctx.currentTime;
        var duration = 0.22;

        var bufSize = Math.floor(ctx.sampleRate * duration);
        var buf = ctx.createBuffer(1, bufSize, ctx.sampleRate);
        var data = buf.getChannelData(0);
        for (var i = 0; i < bufSize; i++) {
          var t = i / bufSize;
          var env = Math.pow(1 - t, 1.6);
          data[i] = (Math.random() * 2 - 1) * env;
        }

        var src = ctx.createBufferSource();
        src.buffer = buf;

        var bp = ctx.createBiquadFilter();
        bp.type = 'bandpass';
        bp.frequency.value = 3200;
        bp.Q.value = 0.7;

        var hp = ctx.createBiquadFilter();
        hp.type = 'highpass';
        hp.frequency.value = 1500;

        var gain = ctx.createGain();
        gain.gain.setValueAtTime(0, now);
        gain.gain.linearRampToValueAtTime(0.22, now + 0.012);
        gain.gain.exponentialRampToValueAtTime(0.001, now + duration);

        src.connect(bp);
        bp.connect(hp);
        hp.connect(gain);
        gain.connect(ctx.destination);
        src.start(now);
        src.stop(now + duration + 0.05);
      } catch (e) { }
    }

    function playFlipSound() {
      if (soundReady && audioPool.length > 0) {
        var a = audioPool[audioIdx];
        audioIdx = (audioIdx + 1) % audioPool.length;
        try { a.currentTime = 0; var p = a.play(); if (p && p.catch) p.catch(function () { }); } catch (e) { }
      } else {
        playSynthFlip();
      }
    }

    function updateInfo() {
      var current = pageFlip.getCurrentPageIndex() + 1;
      if (info) info.textContent = current + ' / ' + pages.length;
      if (prevBtn) prevBtn.disabled = current <= 1;
      if (nextBtn) nextBtn.disabled = current >= pages.length;
    }

    pageFlip.on('flip', function () {
      updateInfo();
      playFlipSound();
    });
    updateInfo();

    if (prevBtn) prevBtn.addEventListener('click', function () { pageFlip.flipPrev(); });
    if (nextBtn) nextBtn.addEventListener('click', function () { pageFlip.flipNext(); });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowLeft') pageFlip.flipPrev();
      if (e.key === 'ArrowRight') pageFlip.flipNext();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
